import { Col } from "reactstrap";
import HealthInfoIcon from "../../assets/job_registration/Health_information.png";
import AgeIcon from "../../assets/job_registration/Age.png";
import GenderIcon from "../../assets/job_registration/Gender.png";
import parseHtml from 'html-react-parser';
import { useEffect, useState } from "react";

const JobMoreInfo = ({job}) => {
    const capitalized = (str) => {
        return str?.charAt(0)?.toUpperCase() + str?.slice(1);
    }
    const [healthInfo, setHealthInfo] = useState("");
    const [additionalInfo, setAdditionalInfo] = useState("");

    useEffect(() => {
        const _healthInfo = job?.additional_health_info;
        let _additionalInfo;
        let _jobDetailsHealthInfo;

        if(_healthInfo != undefined || _healthInfo != null){
            if(_healthInfo.includes("</")){
                const parsedString = parseHtml(_healthInfo);
                setHealthInfo(parsedString?.props.children);
            } else {
                setHealthInfo(_healthInfo)
            }
        } else if (job?.job_details.length > 0){
            _jobDetailsHealthInfo = job?.job_details[0]?.health_condition;
            _additionalInfo = job?.job_details[0]?.additional_info
            if(_jobDetailsHealthInfo.includes("</") || _additionalInfo.includes("</")){
                const parsedHealthString = parseHtml(_jobDetailsHealthInfo);
                const parsedAdditionalString = parseHtml(_additionalInfo)
                setHealthInfo(parsedHealthString?.props?.children);
                setAdditionalInfo(parsedAdditionalString?.props?.children);
            } else {
                setHealthInfo(_jobDetailsHealthInfo);
                setAdditionalInfo(_additionalInfo);
            }
        } else {
            setHealthInfo("-");
            setAdditionalInfo("-")
        }
    }, [job]);

    return (
        <div id="info" style={{marginTop:50}}>
            <div style={{fontWeight: 600, fontSize: 18, marginBottom: 10}}>
                Patient's Info
            </div>
            <Col>
                <div style={{display:"flex", marginBottom: 5}}>
                    <img style={{width:30, height:30}} src= {GenderIcon} alt={GenderIcon}/>
                    <div style={{margin:"auto", marginLeft: 5, fontWeight: 500}}>Gender</div>
                </div>
                <div style={{margin:"auto", marginLeft: 35, marginBottom: 15}}>{job?.job_details? `${capitalized(job?.job_details[0]?.gender) ?? "Prefer not to say"}` : `${job?.job_gender ?? "Prefer not to say"}`}</div>
                
                <div style={{display:"flex", marginBottom: 5}}>
                    <img style={{width:30, height:30}} src= {AgeIcon} alt={AgeIcon}/>
                    <div style={{margin:"auto", marginLeft: 5, fontWeight: 500}}>Age</div>
                </div>
                <div style={{margin:"auto", marginLeft: 35, marginBottom: 15}}>{job?.job_details? `${job?.job_details[0]?.age ?? "Prefer not to say"}` : `${job?.age ?? "Prefer not to say"}`}</div>
                
                <div style={{display:"flex", marginBottom: 5}}>
                    <img style={{width:30, height:30}} src= {AgeIcon} alt={AgeIcon}/>
                    <div style={{margin:"auto", marginLeft: 5, fontWeight: 500}}>Estimated Weight</div>
                </div>
                <div style={{margin:"auto", marginLeft: 35, marginBottom: 15}}>{job?.job_details? `${job?.job_details[0]?.weight ?? "Prefer not to say"}` : `${job?.weight ?? "Prefer not to say"}`}</div>

                <div style={{display:"flex", marginBottom: 5}}>
                    <img style={{width:30, height:30}} src= {AgeIcon} alt={AgeIcon}/>
                    <div style={{margin:"auto", marginLeft: 5, fontWeight: 500}}>Estimated Height</div>
                </div>
                <div style={{margin:"auto", marginLeft: 35, marginBottom: 15}}>{job?.job_details? `${job?.job_details[0]?.height ?? "Prefer not to say"}` : `${job?.height ?? "Prefer not to say"}`}</div>

                <div style={{display:"flex", marginBottom: 5}}>
                    <img style={{width:30, height:30}} src= {HealthInfoIcon} alt={HealthInfoIcon}/>
                    <div style={{margin:"auto", marginLeft: 5, fontWeight: 500}}>Health Info</div>
                </div>
                <div style={{margin:"auto", marginLeft: 35, marginBottom: 15}}>{job?.job_details? `${job?.job_details[0]?.health_condition ?? "-"}` : `${job?.additional_health_info ?? "-"}`}</div>
                
                <div style={{display:"flex", marginBottom: 5}}>
                    <img style={{width:30, height:30}} src= {HealthInfoIcon} alt={HealthInfoIcon}/>
                    <div style={{margin:"auto", marginLeft: 5, fontWeight: 500}}>Additional Info</div>
                </div>
                <div style={{margin:"auto", marginLeft: 35, marginBottom: 15}}>{job?.job_details? `${job?.job_details[0]?.additional_info ?? "-"}` : `${job?.description ?? "-"}`}</div>
            </Col>
        </div>
    )
}

export default JobMoreInfo;